import {
  GET_CREDIT_PLAN_REQUEST,
  GET_CREDIT_PLAN_SUCCESS,
  GET_CREDIT_PLAN_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const creditPlanReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_CREDIT_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_CREDIT_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_CREDIT_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
